import { CheckboxGroup, CheckboxGroupProps, Spacing } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

import { ScrollableListItem } from './elements/ScrollableListItem'
import * as Styled from './styles'

interface ScrollableListProps extends Omit<CheckboxGroupProps, 'children' | 'direction' | 'spacing'> {
  children?: ReactNode
}

type ScrollableListType = {
  Item: typeof ScrollableListItem
}

export const ScrollableList = ({
  children,
  ...checkboxGroupProps
}: ScrollableListProps): ReactElement<ScrollableListType> => (
  <Styled.ScrollableListWrapper>
    <Styled.ScrollableListContent>
      <CheckboxGroup {...checkboxGroupProps} direction="column" spacing={Spacing.S2}>
        {children}
      </CheckboxGroup>
    </Styled.ScrollableListContent>
  </Styled.ScrollableListWrapper>
)

ScrollableList.Item = ScrollableListItem
